import { useState, useEffect } from "react";

// useState-vervanger die de waarde per browser-sessie onthoudt (sessionStorage).
// Zo blijven tab-keuze, zoekterm en filters bewaard tot je de browser sluit.
export function usePersistedState(key, initial) {
  const storageKey = `crmstate:${key}`;
  const [val, setVal] = useState(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      return raw != null ? JSON.parse(raw) : initial;
    } catch { return initial; }
  });
  useEffect(() => {
    try { sessionStorage.setItem(storageKey, JSON.stringify(val)); } catch { /* geen storage */ }
  }, [storageKey, val]);
  return [val, setVal];
}
